import { Link } from "react-router-dom";
import { FadeUp } from "../components/Reveal";

export default function NotFound() {
  return (
    <main data-testid="not-found-page" className="bg-paper">
      <div className="max-w-3xl mx-auto px-6 md:px-12 pt-40 md:pt-52 pb-32">
        <FadeUp>
          <p className="text-[12px] font-semibold uppercase tracking-[0.22em] text-terra">Page not found</p>
          <h1 className="mt-4 font-display text-4xl md:text-5xl tracking-tight">
            This page does not exist.
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-mute">
            The link may be incorrect or the page may have moved.
          </p>
          <Link
            to="/"
            data-testid="notfound-home-link"
            className="mt-10 inline-block bg-ink text-paper text-[12px] font-semibold uppercase tracking-[0.12em] px-6 py-3.5 hover:bg-terra transition-colors duration-300"
          >
            Return to the homepage
          </Link>
        </FadeUp>
      </div>
    </main>
  );
}
